import React from 'react';
import { Link } from 'react-router-dom';

function Product(props) {
    const { product } = props;

    return (
        <div className="product">
            <Link to={product.link} className={product.className}>
                <img
                    className="product-image"
                    src={product.photo}
                    alt="ProductImage"
                />
                <div className="product-name">
                    <h3>{product.name}</h3>
                </div>
                {product.category && (
                    <div className="product-category">
                        <p className="normal-text mt-10">
                            Categoria: {product.category}
                        </p>
                    </div>
                )}
            </Link>
        </div>
    );
}

export default Product;
